<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>提现记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="border-bottom: 1px solid #EEEEEE;padding-bottom: 10px;">
          <el-col :span="24" align="left">&nbsp;
            <el-input
              style="width: 270px"
              placeholder="请输入ID/昵称/支付宝账号/手机号查询"
              v-model="selectkey"
              clearable>
            </el-input>
            <el-button type="primary" @click="getstart()">开始查询</el-button>
          </el-col>

        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%">
          <el-table-column
            label="用户ID"
            prop="user_id">
          </el-table-column>
          <el-table-column
            label="昵称"
            prop="nickname">
          </el-table-column>
          <el-table-column
            label="手机号"
            prop="phone">
          </el-table-column>
          <el-table-column

            label="状态">
            <template slot-scope="scope">
              <span :class="[{redcolor:scope.row.tx_state=='3'},{greencolor:scope.row.tx_state=='2'},{bluecolor:scope.row.tx_state=='1'}]">
                              {{ scope.row.tx_state=='1'?'提现申请中':scope.row.tx_state=='2'?'提现成功':scope.row.tx_state=='3'?'拒绝提现':'未处理' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="tx_type"
            label="提现类型">
            <template slot-scope="scope">
              {{ scope.row.tx_type=='支付宝'?'支付宝':'微信' }}
            </template>
          </el-table-column>
          <el-table-column
            label="支付宝账号"
            prop="zfb_account">
          </el-table-column>
          <el-table-column
            label="申请提现金额"
            prop="money">
          </el-table-column>
          <el-table-column
            label="申请时间"
          >
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作人"
            prop="user_name">
          </el-table-column>
        <el-table-column
            label="实际提现金额"
            prop="tx_money">
          </el-table-column>

         <el-table-column
            label="提现手续费比率"
            prop="tx_service_ratio">
          </el-table-column>
         <el-table-column
            label="手续费"
            prop="tx_service_money">
          </el-table-column>

        <el-table-column
            label="提现时间"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.tx_pay_time) }}
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remarks">
          </el-table-column>

          <el-table-column
            label="操作"
            width="170">
            <template slot-scope="scope">
              <el-button @click="ProcessingMesge(scope.row.balance_id,scope.row.phone)" v-if="scope.row.tx_state!='2'  &&scope.row.tx_state!='3'" size="small" type="text">确认汇款</el-button>
              <el-button v-if="scope.row.tx_state=='2'"  size="small" type="text" style="color: #3b4249" >已确认汇款</el-button>
              <el-button v-if="scope.row.tx_state!='2'  &&scope.row.tx_state!='3'"   size="small" type="text" @click="refuse(scope.row.balance_id)">拒绝提现</el-button>
              <el-button  v-if="scope.row.tx_state=='3'"   size="small" type="text" style="color: #3b4249">已拒绝提现</el-button>

            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>

    </el-row>

    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  export default {
    name: "Finance",
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
    },
    data() {
      return {
        selectkey: '',
        dataa: [],
        datatotal: 0,
        pagesize: 10,
        currentPage: 1,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        activeName: '',
        fullscreenLoading: false,
        //表格
        formLabelWidth: '100px',


      }
    },
    computed: {},
    watch: {},
    methods: {
      //拒绝提现
      refuse(id){
        this.$prompt('', '拒绝原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.mySubmit('refuseTx',{balance_id:id,remarks:value}).then(code=>{
            if(code==200){
              this.getstart()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });


      },
      panduanleixing2(type) {
        switch (type) {
          case '1':
            return "";
            break;
          case '2':
            return "success";
            break;
          case '3':
            return "success";
            break;
          case '4':
            return "info";
            break;
          default:
            return null;
        }
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.listTx, {
          page: thi.currentPage,
          pageSize: thi.pagesize,
          key:thi.selectkey
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.dataa = qdata
            thi.datatotal = qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      handleNodeClick(data) {
        console.log(data);
      },

      //处理提示
      ProcessingMesge(id,phone) {
        let thi = this
        thi.$confirm('是否确认处理?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.Processing(id,phone)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //处理
      Processing(id,phone) {
        let thi = this
        thi.fullscreenLoading = true
        console.log(id)
        this.$http.post(global.posturl.host + global.posturl.allowTx, {
          balance_id: id,
          // phone:phone
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //格式化时间
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //状态改变（启用）
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userStateChange, {
          user_id: user_id,
          state: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //白名单状态改变
      changeUserState(user_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userwhitelistChange, {
          user_id: user_id,
          whitelist: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .greencolor {
    color: #67C23A;
  }

  .redcolor {
    color: #F56C6C;
  }
</style>



// WEBPACK FOOTER //
// src/page/finance/Finance.vue